import { default as indexBKMfURxQvTMeta } from "/opt/build/repo/app/pages/agarwood-plantation-ownership/book-discovery-call/index.vue?macro=true";
import { default as indexKDMiw3VrxqMeta } from "/opt/build/repo/app/pages/agarwood-plantation-ownership/download-free-guide/index.vue?macro=true";
import { default as indexw94V5aPyWLMeta } from "/opt/build/repo/app/pages/agarwood-plantation-ownership/index.vue?macro=true";
import { default as indexvWLr9MlQcPMeta } from "/opt/build/repo/app/pages/associates/al-hashimi/index.vue?macro=true";
import { default as index6GrhAnBpnkMeta } from "/opt/build/repo/app/pages/associates/ghallia/index.vue?macro=true";
import { default as indexnCx7PJTjksMeta } from "/opt/build/repo/app/pages/associates/index.vue?macro=true";
import { default as indexX5jeek95BAMeta } from "/opt/build/repo/app/pages/associates/ouddict-artisanal-oud-community/index.vue?macro=true";
import { default as indexBEa9tPMGo2Meta } from "/opt/build/repo/app/pages/authenticated/admin/appointments/index.vue?macro=true";
import { default as indexo8FYxpD3AEMeta } from "/opt/build/repo/app/pages/authenticated/admin/brevo/index.vue?macro=true";
import { default as indexC5Mx8Yr8MlMeta } from "/opt/build/repo/app/pages/authenticated/admin/dashboard/index.vue?macro=true";
import { default as _91id_935a9nY67vQ0Meta } from "/opt/build/repo/app/pages/authenticated/admin/leads/[id].vue?macro=true";
import { default as indexn1T6VAc0IHMeta } from "/opt/build/repo/app/pages/authenticated/admin/leads/index.vue?macro=true";
import { default as indexpflOmIw0O0Meta } from "/opt/build/repo/app/pages/authenticated/admin/messages/index.vue?macro=true";
import { default as indexpkrBHs0H5fMeta } from "/opt/build/repo/app/pages/authenticated/member/dashboard/index.vue?macro=true";
import { default as indexOYGowrrXtKMeta } from "/opt/build/repo/app/pages/corporate/book-a-discovery-call/index.vue?macro=true";
import { default as indexoew2b5Rf8oMeta } from "/opt/build/repo/app/pages/corporate/careers/index.vue?macro=true";
import { default as index8WkvtqbG03Meta } from "/opt/build/repo/app/pages/corporate/contact-us/index.vue?macro=true";
import { default as indexMBiGFwpgsXMeta } from "/opt/build/repo/app/pages/corporate/core-values/index.vue?macro=true";
import { default as indexqdFVpIDZPaMeta } from "/opt/build/repo/app/pages/corporate/index.vue?macro=true";
import { default as indexyLueI1rrFiMeta } from "/opt/build/repo/app/pages/corporate/investor-relations/agarwood/discover-the-gold-standard-of-nature/index.vue?macro=true";
import { default as indexUiyJ9WPMbFMeta } from "/opt/build/repo/app/pages/corporate/investor-relations/agarwood/why-agarwood-is-the-investment-of-the-future/index.vue?macro=true";
import { default as indexsJxx7KkqWgMeta } from "/opt/build/repo/app/pages/corporate/investor-relations/discovery-call/index.vue?macro=true";
import { default as index7gNzuUpYLnMeta } from "/opt/build/repo/app/pages/corporate/investor-relations/download-report/index.vue?macro=true";
import { default as indexr2S9cVbPxuMeta } from "/opt/build/repo/app/pages/corporate/investor-relations/index.vue?macro=true";
import { default as indexj0MBfRHKvDMeta } from "/opt/build/repo/app/pages/corporate/meet-the-team/index.vue?macro=true";
import { default as index9QtG0JCDh2Meta } from "/opt/build/repo/app/pages/index.vue?macro=true";
import { default as indexUOwvfozwWpMeta } from "/opt/build/repo/app/pages/legal/anti-deforestation-policy/index.vue?macro=true";
import { default as indexa2XKYil9KyMeta } from "/opt/build/repo/app/pages/legal/anti-slavery-policy/index.vue?macro=true";
import { default as indexXeq9EYJ2SCMeta } from "/opt/build/repo/app/pages/legal/code-of-ethics/index.vue?macro=true";
import { default as indexauiKWv0pbQMeta } from "/opt/build/repo/app/pages/legal/cookie-policy/index.vue?macro=true";
import { default as indexDxAYlaG0sdMeta } from "/opt/build/repo/app/pages/legal/disclaimer/index.vue?macro=true";
import { default as indexPdyWxwLt5aMeta } from "/opt/build/repo/app/pages/legal/index.vue?macro=true";
import { default as indexkWaVUkm2K1Meta } from "/opt/build/repo/app/pages/legal/privacy-policy/index.vue?macro=true";
import { default as indexfGznUjriLSMeta } from "/opt/build/repo/app/pages/legal/sustainability-policy/index.vue?macro=true";
import { default as indexPqqtshLs9nMeta } from "/opt/build/repo/app/pages/legal/terms-of-use/index.vue?macro=true";
import { default as indexNxSVSbpHYcMeta } from "/opt/build/repo/app/pages/opportunities/agarwood-oil-and-chips/index.vue?macro=true";
import { default as indexfG2IagWDx9Meta } from "/opt/build/repo/app/pages/opportunities/index.vue?macro=true";
import { default as indexeju5K9nr04Meta } from "/opt/build/repo/app/pages/opportunities/plantation-ownership/index.vue?macro=true";
import { default as indexeFOAI8AQhhMeta } from "/opt/build/repo/app/pages/plantations/agarwood-plantations/index.vue?macro=true";
import { default as indexr08vnhd9xHMeta } from "/opt/build/repo/app/pages/plantations/carbon-neutral-agriculture/index.vue?macro=true";
import { default as index4STfo55LecMeta } from "/opt/build/repo/app/pages/plantations/index.vue?macro=true";
import { default as indexSnsL94b3i7Meta } from "/opt/build/repo/app/pages/plantations/plantation-challenges/index.vue?macro=true";
import { default as index3H5AlPCKwHMeta } from "/opt/build/repo/app/pages/plantations/professional-management/index.vue?macro=true";
import { default as indexcAjVmW9QbuMeta } from "/opt/build/repo/app/pages/sustainability/agriculture-asset-class/index.vue?macro=true";
import { default as indexFEK7qQgezPMeta } from "/opt/build/repo/app/pages/sustainability/global-warming-initiative/index.vue?macro=true";
import { default as indexmRjzaATt4aMeta } from "/opt/build/repo/app/pages/sustainability/index.vue?macro=true";
import { default as indexv2XEfpPbmnMeta } from "/opt/build/repo/app/pages/sustainability/regenerative-practices/index.vue?macro=true";
import { default as indexplBxL5Vc97Meta } from "/opt/build/repo/app/pages/sustainability/sustainable-future/index.vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "agarwood-plantation-ownership-book-discovery-call",
    path: "/agarwood-plantation-ownership/book-discovery-call",
    meta: indexBKMfURxQvTMeta || {},
    component: () => import("/opt/build/repo/app/pages/agarwood-plantation-ownership/book-discovery-call/index.vue")
  },
  {
    name: "agarwood-plantation-ownership-download-free-guide",
    path: "/agarwood-plantation-ownership/download-free-guide",
    meta: indexKDMiw3VrxqMeta || {},
    component: () => import("/opt/build/repo/app/pages/agarwood-plantation-ownership/download-free-guide/index.vue")
  },
  {
    name: "agarwood-plantation-ownership",
    path: "/agarwood-plantation-ownership",
    meta: indexw94V5aPyWLMeta || {},
    component: () => import("/opt/build/repo/app/pages/agarwood-plantation-ownership/index.vue")
  },
  {
    name: "associates-al-hashimi",
    path: "/associates/al-hashimi",
    meta: indexvWLr9MlQcPMeta || {},
    component: () => import("/opt/build/repo/app/pages/associates/al-hashimi/index.vue")
  },
  {
    name: "associates-ghallia",
    path: "/associates/ghallia",
    meta: index6GrhAnBpnkMeta || {},
    component: () => import("/opt/build/repo/app/pages/associates/ghallia/index.vue")
  },
  {
    name: "associates",
    path: "/associates",
    meta: indexnCx7PJTjksMeta || {},
    component: () => import("/opt/build/repo/app/pages/associates/index.vue")
  },
  {
    name: "associates-ouddict-artisanal-oud-community",
    path: "/associates/ouddict-artisanal-oud-community",
    meta: indexX5jeek95BAMeta || {},
    component: () => import("/opt/build/repo/app/pages/associates/ouddict-artisanal-oud-community/index.vue")
  },
  {
    name: "authenticated-admin-appointments",
    path: "/authenticated/admin/appointments",
    meta: indexBEa9tPMGo2Meta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/appointments/index.vue")
  },
  {
    name: "authenticated-admin-brevo",
    path: "/authenticated/admin/brevo",
    meta: indexo8FYxpD3AEMeta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/brevo/index.vue")
  },
  {
    name: "authenticated-admin-dashboard",
    path: "/authenticated/admin/dashboard",
    meta: indexC5Mx8Yr8MlMeta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/dashboard/index.vue")
  },
  {
    name: "authenticated-admin-leads-id",
    path: "/authenticated/admin/leads/:id()",
    meta: _91id_935a9nY67vQ0Meta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/leads/[id].vue")
  },
  {
    name: "authenticated-admin-leads",
    path: "/authenticated/admin/leads",
    meta: indexn1T6VAc0IHMeta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/leads/index.vue")
  },
  {
    name: "authenticated-admin-messages",
    path: "/authenticated/admin/messages",
    meta: indexpflOmIw0O0Meta || {},
    component: () => import("/opt/build/repo/app/pages/authenticated/admin/messages/index.vue")
  },
  {
    name: "authenticated-member-dashboard",
    path: "/authenticated/member/dashboard",
    component: () => import("/opt/build/repo/app/pages/authenticated/member/dashboard/index.vue")
  },
  {
    name: "corporate-book-a-discovery-call",
    path: "/corporate/book-a-discovery-call",
    meta: indexOYGowrrXtKMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/book-a-discovery-call/index.vue")
  },
  {
    name: "corporate-careers",
    path: "/corporate/careers",
    meta: indexoew2b5Rf8oMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/careers/index.vue")
  },
  {
    name: "corporate-contact-us",
    path: "/corporate/contact-us",
    meta: index8WkvtqbG03Meta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/contact-us/index.vue")
  },
  {
    name: "corporate-core-values",
    path: "/corporate/core-values",
    meta: indexMBiGFwpgsXMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/core-values/index.vue")
  },
  {
    name: "corporate",
    path: "/corporate",
    meta: indexqdFVpIDZPaMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/index.vue")
  },
  {
    name: "corporate-investor-relations-agarwood-discover-the-gold-standard-of-nature",
    path: "/corporate/investor-relations/agarwood/discover-the-gold-standard-of-nature",
    meta: indexyLueI1rrFiMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/investor-relations/agarwood/discover-the-gold-standard-of-nature/index.vue")
  },
  {
    name: "corporate-investor-relations-agarwood-why-agarwood-is-the-investment-of-the-future",
    path: "/corporate/investor-relations/agarwood/why-agarwood-is-the-investment-of-the-future",
    meta: indexUiyJ9WPMbFMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/investor-relations/agarwood/why-agarwood-is-the-investment-of-the-future/index.vue")
  },
  {
    name: "corporate-investor-relations-discovery-call",
    path: "/corporate/investor-relations/discovery-call",
    meta: indexsJxx7KkqWgMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/investor-relations/discovery-call/index.vue")
  },
  {
    name: "corporate-investor-relations-download-report",
    path: "/corporate/investor-relations/download-report",
    meta: index7gNzuUpYLnMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/investor-relations/download-report/index.vue")
  },
  {
    name: "corporate-investor-relations",
    path: "/corporate/investor-relations",
    meta: indexr2S9cVbPxuMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/investor-relations/index.vue")
  },
  {
    name: "corporate-meet-the-team",
    path: "/corporate/meet-the-team",
    meta: indexj0MBfRHKvDMeta || {},
    component: () => import("/opt/build/repo/app/pages/corporate/meet-the-team/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index9QtG0JCDh2Meta || {},
    component: () => import("/opt/build/repo/app/pages/index.vue")
  },
  {
    name: "legal-anti-deforestation-policy",
    path: "/legal/anti-deforestation-policy",
    meta: indexUOwvfozwWpMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/anti-deforestation-policy/index.vue")
  },
  {
    name: "legal-anti-slavery-policy",
    path: "/legal/anti-slavery-policy",
    meta: indexa2XKYil9KyMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/anti-slavery-policy/index.vue")
  },
  {
    name: "legal-code-of-ethics",
    path: "/legal/code-of-ethics",
    meta: indexXeq9EYJ2SCMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/code-of-ethics/index.vue")
  },
  {
    name: "legal-cookie-policy",
    path: "/legal/cookie-policy",
    meta: indexauiKWv0pbQMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/cookie-policy/index.vue")
  },
  {
    name: "legal-disclaimer",
    path: "/legal/disclaimer",
    meta: indexDxAYlaG0sdMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/disclaimer/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: indexPdyWxwLt5aMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/index.vue")
  },
  {
    name: "legal-privacy-policy",
    path: "/legal/privacy-policy",
    meta: indexkWaVUkm2K1Meta || {},
    component: () => import("/opt/build/repo/app/pages/legal/privacy-policy/index.vue")
  },
  {
    name: "legal-sustainability-policy",
    path: "/legal/sustainability-policy",
    meta: indexfGznUjriLSMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/sustainability-policy/index.vue")
  },
  {
    name: "legal-terms-of-use",
    path: "/legal/terms-of-use",
    meta: indexPqqtshLs9nMeta || {},
    component: () => import("/opt/build/repo/app/pages/legal/terms-of-use/index.vue")
  },
  {
    name: "opportunities-agarwood-oil-and-chips",
    path: "/opportunities/agarwood-oil-and-chips",
    meta: indexNxSVSbpHYcMeta || {},
    component: () => import("/opt/build/repo/app/pages/opportunities/agarwood-oil-and-chips/index.vue")
  },
  {
    name: "opportunities",
    path: "/opportunities",
    meta: indexfG2IagWDx9Meta || {},
    component: () => import("/opt/build/repo/app/pages/opportunities/index.vue")
  },
  {
    name: "opportunities-plantation-ownership",
    path: "/opportunities/plantation-ownership",
    meta: indexeju5K9nr04Meta || {},
    component: () => import("/opt/build/repo/app/pages/opportunities/plantation-ownership/index.vue")
  },
  {
    name: "plantations-agarwood-plantations",
    path: "/plantations/agarwood-plantations",
    meta: indexeFOAI8AQhhMeta || {},
    component: () => import("/opt/build/repo/app/pages/plantations/agarwood-plantations/index.vue")
  },
  {
    name: "plantations-carbon-neutral-agriculture",
    path: "/plantations/carbon-neutral-agriculture",
    meta: indexr08vnhd9xHMeta || {},
    component: () => import("/opt/build/repo/app/pages/plantations/carbon-neutral-agriculture/index.vue")
  },
  {
    name: "plantations",
    path: "/plantations",
    meta: index4STfo55LecMeta || {},
    component: () => import("/opt/build/repo/app/pages/plantations/index.vue")
  },
  {
    name: "plantations-plantation-challenges",
    path: "/plantations/plantation-challenges",
    meta: indexSnsL94b3i7Meta || {},
    component: () => import("/opt/build/repo/app/pages/plantations/plantation-challenges/index.vue")
  },
  {
    name: "plantations-professional-management",
    path: "/plantations/professional-management",
    meta: index3H5AlPCKwHMeta || {},
    component: () => import("/opt/build/repo/app/pages/plantations/professional-management/index.vue")
  },
  {
    name: "sustainability-agriculture-asset-class",
    path: "/sustainability/agriculture-asset-class",
    meta: indexcAjVmW9QbuMeta || {},
    component: () => import("/opt/build/repo/app/pages/sustainability/agriculture-asset-class/index.vue")
  },
  {
    name: "sustainability-global-warming-initiative",
    path: "/sustainability/global-warming-initiative",
    meta: indexFEK7qQgezPMeta || {},
    component: () => import("/opt/build/repo/app/pages/sustainability/global-warming-initiative/index.vue")
  },
  {
    name: "sustainability",
    path: "/sustainability",
    meta: indexmRjzaATt4aMeta || {},
    component: () => import("/opt/build/repo/app/pages/sustainability/index.vue")
  },
  {
    name: "sustainability-regenerative-practices",
    path: "/sustainability/regenerative-practices",
    meta: indexv2XEfpPbmnMeta || {},
    component: () => import("/opt/build/repo/app/pages/sustainability/regenerative-practices/index.vue")
  },
  {
    name: "sustainability-sustainable-future",
    path: "/sustainability/sustainable-future",
    meta: indexplBxL5Vc97Meta || {},
    component: () => import("/opt/build/repo/app/pages/sustainability/sustainable-future/index.vue")
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/_nuxt",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/api/_content",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/hello-world",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/*/feed",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/community-involvement-and-fair-practices",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/organic-cultivation",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/transparency-reporting-and-collaboration",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/education-and-training",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/cultivating-diversity",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/renewable-energy-revolution",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/permaculture-principles-and-ethics",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/sustainable-harvesting-techniques",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/innovation-and-sustainable-excellence",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/soil-and-water-stewardship",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/wildlife-and-ecosystem-conservation",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sustainability/responsible-waste-management",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/exclusive-ouddict-offer",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/exclusive-and-limited-ouddict-offer",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/prosper-with-nature",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/cites-regulation",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/the-art-and-challenge",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/meet-our-team",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/blog/:pathMatch(.*)",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/careers",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/industry-associates",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/scented-spiritual-practice",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/scented-spiritual-practice/:pathMatch(.*)",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/contacts",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/the-benefits-of-entrusting",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/landingpage",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/landingpage/:pathMatch(.*)",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/latest-update",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/inducing-agarwood-resin",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/faqs",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/about",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/our-principles",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/monoculture-plantations",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/partnership-program",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/the-essence-of-luxury-parfum",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/agarwood-in-beauty-and-cosmetics",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/anti-corruption-statement",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/ethics-policy",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/privacy-statement",
    component: component_45stubRU5sOBTecH
  }
]